import {
  ApiServices,
  BetsService,
  // UsersService,
  ApiServiceTypes,
  environmentBuilder,
  TranslationService,
  DefaultQueryParams,
  parseQuery,
} from '@pascal/pascal-core';
import { ComboKeno10, ComboKeno8, ComboKeno8GameId } from '../../core/constants/appDefaultValues';

export const registerApis = () => {
  const { [DefaultQueryParams.GameId]: gameId } = parseQuery(window.location.search);
  const gameName = +gameId === ComboKeno8GameId ? ComboKeno8 : ComboKeno10;

  const { httpUrl: url, httpTranslationUrl } = environmentBuilder(gameName);

  ApiServices.register(ApiServiceTypes.BetsService, new BetsService({ url }));
  ApiServices.register(
    ApiServiceTypes.TranslationService,
    new TranslationService({ url: httpTranslationUrl })
  );
};
